import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';

const API = '';
const tok = () => localStorage.getItem('nexus_token') || localStorage.getItem('vgo_token') || '';
const hdr = () => ({ 'Content-Type':'application/json', Authorization:`Bearer ${tok()}` });

const LEVEL_CONFIG = {
  0:{label:'Basic',color:'#94a3b8',bg:'#f1f5f9',icon:'⚪',desc:'Profile created'},
  1:{label:'Profile Verified',color:'#f59e0b',bg:'#fef3c7',icon:'🟡',desc:'Photo, bio & location confirmed'},
  2:{label:'Identity Declared',color:'#f97316',bg:'#fff7ed',icon:'🟠',desc:'Government ID type declared'},
  3:{label:'Address & Education',color:'#10b981',bg:'#ecfdf5',icon:'🟢',desc:'Address & education history added'},
  4:{label:'Fully Verified',color:'#1a3cc8',bg:'#eff6ff',icon:'🔵',desc:'Complete genuine profile'},
};

const ID_TYPES = {
  passport:'Passport', aadhaar:'Aadhaar', pan:'PAN Card', driving:'Driving License',
  voter:'Voter ID', national:'National ID', other:'Other Govt ID',
};

export default function GAPProfileScreen() {
  const nav = useNavigate();
  const { id } = useParams();
  const [profile,    setProfile]    = useState(null);
  const [experience, setExperience] = useState([]);
  const [education,  setEducation]  = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showFlag,   setShowFlag]   = useState(false);
  const [flagReason, setFlagReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const myId = (() => { try { const t=tok(); if(!t) return null; const p=JSON.parse(atob(t.split('.')[1])); return p.sub; } catch(e){ return null; } })();
  const isOwner = myId === id;

  useEffect(() => {
    Promise.all([
      fetch(`${API}/api/backend/v1/gap/profile/${id}`, { headers: hdr() }).then(r=>r.json()),
      fetch(`${API}/api/backend/v1/gap/profile/${id}/experience`, { headers: hdr() }).then(r=>r.json()),
      fetch(`${API}/api/backend/v1/gap/profile/${id}/education`, { headers: hdr() }).then(r=>r.json()),
    ]).then(([p, e, ed]) => {
      setProfile(p.user_id ? p : null);
      setExperience(e.experience || []);
      setEducation(ed.education || []);
    }).catch(()=>{}).finally(()=>setLoading(false));
  }, [id]);

  const submitFlag = async () => {
    if (!flagReason) { toast.error('Select a reason'); return; }
    setSubmitting(true);
    try {
      await fetch(`${API}/api/backend/v1/gap/flag`, { method:'POST', headers:hdr(), body:JSON.stringify({reported_id:id,reason:flagReason}) });
      toast.success('Reported. Our team will review.');
      setShowFlag(false);
    } catch(e) { toast.error('Failed'); }
    finally { setSubmitting(false); }
  };

  if (loading) return <div style={{padding:60,textAlign:'center',color:'#1a3cc8',fontSize:32}}>🔍</div>;
  if (!profile) return (
    <div style={{padding:40,textAlign:'center'}}>
      <div style={{fontSize:48,marginBottom:12}}>📋</div>
      <div style={{fontSize:16,fontWeight:700,color:'#1e293b',marginBottom:8}}>Profile not found</div>
      <button onClick={()=>nav(-1)} style={{background:'#1a3cc8',border:'none',borderRadius:10,padding:'10px 24px',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer'}}>Go Back</button>
    </div>
  );

  const lvl = LEVEL_CONFIG[profile.verification_level] || LEVEL_CONFIG[0];

  return (
    <div style={{ maxWidth:430, margin:'0 auto', background:'#f8fafc', minHeight:'100vh', paddingBottom:80 }}>

      {/* Header photo / banner */}
      <div style={{ position:'relative' }}>
        <div style={{ height:140, background:'linear-gradient(135deg,#1a3cc8,#7c3aed)' }} />
        <div style={{ position:'absolute', top:52, left:16 }}>
          <button onClick={()=>nav(-1)} style={{ background:'rgba(255,255,255,0.2)', border:'none', borderRadius:10, width:36, height:36, color:'#fff', fontSize:18, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>‹</button>
        </div>
        {isOwner && (
          <div style={{ position:'absolute', top:52, right:16 }}>
            <div style={{display:'flex',gap:8}}>
              {isOwn && <button onClick={()=>nav('/gap/edit')}
                style={{background:'rgba(255,255,255,0.2)',border:'none',borderRadius:10,
                  padding:'7px 14px',color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                ✏️ Edit
              </button>}
              {isOwn && <button onClick={()=>{
                const url=`${window.location.origin}/gap/profile/${uid}`;
                if(navigator.share){navigator.share({title:'My GAP Profile',url});}
                else{navigator.clipboard.writeText(url);alert('Link copied!');}
              }} style={{background:'rgba(255,255,255,0.2)',border:'none',borderRadius:10,
                padding:'7px 14px',color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                🔗 Share
              </button>}
              {!isOwn && !reqSent && <button onClick={()=>setShowRequest(true)}
                style={{background:'rgba(255,255,255,0.2)',border:'none',borderRadius:10,
                  padding:'7px 14px',color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer'}}>
                🔑 Request Access
              </button>}
              {!isOwn && reqSent && <span style={{background:'rgba(255,255,255,0.2)',
                borderRadius:10,padding:'7px 14px',color:'#fff',fontSize:11,fontWeight:700}}>
                ✅ Requested
              </span>}
            </div>
          </div>
        )}
        <div style={{ position:'absolute', bottom:-36, left:20 }}>
          <div style={{ width:72, height:72, borderRadius:36, background: profile.profile_photo?`url(${profile.profile_photo}) center/cover`:'linear-gradient(135deg,#1a3cc8,#7c3aed)', border:'3px solid #fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:28, fontWeight:800, color:'#fff' }}>
            {!profile.profile_photo && profile.display_name[0]}
          </div>
        </div>
      </div>

      <div style={{ padding:'48px 16px 0' }}>

        {/* Name + badges */}
        <div style={{ marginBottom:12 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div>
              <div style={{ fontSize:22, fontWeight:900, color:'#0f172a', letterSpacing:-0.5 }}>{profile.display_name}</div>
              {profile.current_city && <div style={{ fontSize:12, color:'#64748b', marginTop:2 }}>📍 {[profile.current_city, profile.current_country].filter(Boolean).join(', ')}</div>}
            </div>
            {profile.is_available && (
              <span style={{ background:'#ecfdf5', color:'#065f46', borderRadius:10, padding:'4px 10px', fontSize:11, fontWeight:700 }}>✓ Available</span>
            )}
          </div>

          {/* Verification level */}
          <div style={{ marginTop:10, background:lvl.bg, border:`1px solid ${lvl.color}30`, borderRadius:12, padding:'10px 14px', display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ fontSize:22 }}>{lvl.icon}</div>
            <div>
              <div style={{ fontSize:13, fontWeight:800, color:lvl.color }}>{lvl.label}</div>
              <div style={{ fontSize:11, color:'#64748b' }}>{lvl.desc}</div>
            </div>
            <div style={{ marginLeft:'auto', display:'flex', gap:3 }}>
              {[0,1,2,3,4].map(i=>(
                <div key={i} style={{ width:8, height:8, borderRadius:'50%', background:i<=profile.verification_level?lvl.color:'#e2e8f0' }} />
              ))}
            </div>
          </div>
        </div>

        {/* Bio */}
        {profile.bio && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:6 }}>About</div>
            <div style={{ fontSize:13, color:'#334155', lineHeight:1.6 }}>{profile.bio}</div>
          </div>
        )}

        {/* Identity section */}
        {profile.verification_level >= 2 && (profile.id_type || profile.nationality) && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:10 }}>🪪 Identity</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              {profile.nationality && <div><div style={{ fontSize:10, color:'#94a3b8' }}>Nationality</div><div style={{ fontSize:13, fontWeight:600, color:'#0f172a' }}>{profile.nationality}</div></div>}
              {profile.id_type && <div><div style={{ fontSize:10, color:'#94a3b8' }}>ID Type</div><div style={{ fontSize:13, fontWeight:600, color:'#0f172a' }}>{ID_TYPES[profile.id_type]||profile.id_type}{profile.id_partial?` ••••${profile.id_partial}`:''}</div></div>}
              {profile.gender && <div><div style={{ fontSize:10, color:'#94a3b8' }}>Gender</div><div style={{ fontSize:13, fontWeight:600, color:'#0f172a', textTransform:'capitalize' }}>{profile.gender.replace('_',' ')}</div></div>}
            </div>
          </div>
        )}

        {/* Skills */}
        {profile.skills?.length > 0 && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:8 }}>💡 Skills</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
              {profile.skills.map((sk,i)=>(
                <span key={i} style={{ background:'#eff6ff', color:'#1a3cc8', padding:'4px 12px', borderRadius:20, fontSize:12, fontWeight:600, border:'1px solid #bfdbfe' }}>{sk}</span>
              ))}
            </div>
          </div>
        )}

        {/* Languages */}
        {profile.languages?.length > 0 && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:8 }}>🌐 Languages</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
              {profile.languages.map((l,i)=>(
                <span key={i} style={{ background:'#f5f3ff', color:'#7c3aed', padding:'4px 12px', borderRadius:20, fontSize:12, fontWeight:600 }}>{l}</span>
              ))}
            </div>
          </div>
        )}

        {/* Experience */}
        {experience.length > 0 && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:10 }}>💼 Experience</div>
            {experience.map((e,i)=>(
              <div key={e.id} style={{ paddingBottom: i<experience.length-1?12:0, marginBottom:i<experience.length-1?12:0, borderBottom:i<experience.length-1?'1px solid #f1f5f9':'none' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700, color:'#0f172a' }}>{e.role}</div>
                    <div style={{ fontSize:12, color:'#1a3cc8', fontWeight:600 }}>{e.company}</div>
                    {e.location && <div style={{ fontSize:11, color:'#64748b' }}>📍 {e.location}</div>}
                  </div>
                  <div style={{ textAlign:'right', fontSize:10, color:'#94a3b8' }}>
                    {e.start_date?.slice(0,7)} — {e.is_current?'Present':e.end_date?.slice(0,7)||''}
                    {e.is_current && <div style={{ background:'#ecfdf5', color:'#065f46', borderRadius:6, padding:'1px 6px', fontSize:9, fontWeight:700, marginTop:2 }}>Current</div>}
                  </div>
                </div>
                {e.description && <div style={{ fontSize:12, color:'#64748b', marginTop:6, lineHeight:1.5 }}>{e.description}</div>}
              </div>
            ))}
          </div>
        )}

        {/* Education */}
        {education.length > 0 && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:10 }}>🎓 Education</div>
            {education.map((e,i)=>(
              <div key={e.id} style={{ paddingBottom:i<education.length-1?12:0, marginBottom:i<education.length-1?12:0, borderBottom:i<education.length-1?'1px solid #f1f5f9':'none' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={{ fontSize:14, fontWeight:700, color:'#0f172a' }}>{e.degree}{e.field?` in ${e.field}`:''}</div>
                    <div style={{ fontSize:12, color:'#1a3cc8', fontWeight:600 }}>{e.institution}</div>
                  </div>
                  <div style={{ fontSize:10, color:'#94a3b8' }}>
                    {e.start_year} — {e.is_current?'Present':e.end_year||''}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Certifications */}
        {certs.length > 0 && (
          <div style={{marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:'#94a3b8',
              textTransform:'uppercase',marginBottom:10}}>🏆 Certifications</div>
            {certs.map((c,i)=>(
              <div key={i} style={{background:'#fff',borderRadius:12,
                padding:'12px 14px',marginBottom:8,
                border:'1px solid #f1f5f9',
                display:'flex',alignItems:'flex-start',gap:12}}>
                <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                  background:'#fef3c7',display:'flex',alignItems:'center',
                  justifyContent:'center',fontSize:18}}>🎓</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>
                    {c.title}
                    {c.is_verified && <span style={{fontSize:9,background:'#dcfce7',
                      color:'#16a34a',padding:'2px 6px',borderRadius:8,
                      fontWeight:700,marginLeft:6}}>✅ VERIFIED</span>}
                  </div>
                  <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{c.issuer}</div>
                  {c.issued_year && <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>
                    Issued {c.issued_year}{c.expiry_year?` · Expires ${c.expiry_year}`:''}
                  </div>}
                  {c.cert_url && <a href={c.cert_url} target="_blank" rel="noreferrer"
                    style={{fontSize:11,color:'#1a3cc8',marginTop:4,display:'block'}}>
                    🔗 View Certificate
                  </a>}
                </div>
              </div>
            ))}
          </div>
        )}
        {/* Resume Download */}
        {resumes.length > 0 && (
          <div style={{marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:'#94a3b8',
              textTransform:'uppercase',marginBottom:10}}>📄 Resume</div>
            {resumes.map((r,i)=>(
              <a key={i} href={r.file_url} target="_blank" rel="noreferrer"
                style={{display:'flex',alignItems:'center',gap:12,
                  background:'#fff',borderRadius:12,padding:'12px 14px',
                  marginBottom:8,border:'1px solid #f1f5f9',textDecoration:'none'}}>
                <div style={{width:40,height:40,borderRadius:10,
                  background:'#eff6ff',display:'flex',alignItems:'center',
                  justifyContent:'center',fontSize:20,flexShrink:0}}>📄</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>
                    {r.file_name}
                  </div>
                  <div style={{fontSize:11,color:'#1a3cc8',marginTop:2}}>
                    Tap to view/download →
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}
        {/* Portfolio */}
        {profile.portfolio_links?.length > 0 && (
          <div style={{ background:'#fff', borderRadius:14, padding:14, marginBottom:12, border:'1px solid #f1f5f9' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', marginBottom:8 }}>🔗 Portfolio</div>
            {profile.portfolio_links.map((link,i)=>(
              <a key={i} href={link} target="_blank" rel="noopener noreferrer" style={{ display:'block', fontSize:12, color:'#1a3cc8', marginBottom:4, wordBreak:'break-all' }}>{link}</a>
            ))}
          </div>
        )}

        {/* Footer actions */}
        <div style={{ display:'flex', gap:8, marginTop:4 }}>
          {profile.profile_views > 0 && <div style={{ flex:1, background:'#fff', borderRadius:10, padding:'8px', textAlign:'center', border:'1px solid #f1f5f9', fontSize:10, color:'#94a3b8' }}>👁 {profile.profile_views} views</div>}
          {!isOwner && tok() && (
            <button onClick={()=>setShowFlag(true)} style={{ background:'#fef2f2', border:'1px solid #fca5a5', borderRadius:10, padding:'8px 14px', color:'#ef4444', fontSize:11, fontWeight:600, cursor:'pointer' }}>⚠️ Flag</button>
          )}
        </div>
      </div>

      {/* Flag Modal */}
      {showFlag && (
        <div onClick={()=>setShowFlag(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:9999, display:'flex', alignItems:'flex-end', justifyContent:'center' }}>
          <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:'20px 20px 0 0', width:'100%', maxWidth:430, padding:20 }}>
            <div style={{ fontSize:16, fontWeight:800, color:'#1e293b', marginBottom:4 }}>Flag Profile</div>
            <div style={{ fontSize:11, color:'#64748b', marginBottom:14 }}>Report a genuine concern about this profile.</div>
            {['Fake identity','Misleading information','Fraudulent claims','Impersonation','Inappropriate content','Other'].map(r=>(
              <div key={r} onClick={()=>setFlagReason(r)} style={{ padding:'10px 14px', background:flagReason===r?'#fef2f2':'#f8fafc', border:`1px solid ${flagReason===r?'#ef4444':'#e2e8f0'}`, borderRadius:10, marginBottom:6, cursor:'pointer', fontSize:13, color:flagReason===r?'#991b1b':'#334155', fontWeight:flagReason===r?700:400 }}>{r}</div>
            ))}
            <button onClick={submitFlag} disabled={submitting||!flagReason} style={{ width:'100%', marginTop:10, background:'#ef4444', border:'none', borderRadius:12, padding:'12px', color:'#fff', fontSize:14, fontWeight:800, cursor:submitting||!flagReason?'default':'pointer', opacity:flagReason?1:0.5 }}>Submit Flag</button>
          </div>
        </div>
      )}
    {/* Request Access Modal */}
    {showRequest && (
      <div onClick={()=>setShowRequest(false)} style={{position:'fixed',inset:0,
        background:'rgba(0,0,0,0.7)',zIndex:9999,display:'flex',
        alignItems:'flex-end',justifyContent:'center'}}>
        <div onClick={e=>e.stopPropagation()} style={{background:'#fff',
          borderRadius:'20px 20px 0 0',width:'100%',maxWidth:430,padding:20}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1e293b',marginBottom:4}}>
            🔑 Request Profile Access
          </div>
          <div style={{fontSize:11,color:'#64748b',marginBottom:16}}>
            {profile?.display_name} will be notified and can approve or decline
          </div>
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,fontWeight:700,color:'#334155',marginBottom:8}}>
              Select fields to request:
            </div>
            {['education','experience','skills','certifications','identity','contact','address','languages','portfolio'].map(f=>(
              <div key={f} onClick={()=>setReqFields(p=>p.includes(f)?p.filter(x=>x!==f):[...p,f])}
                style={{display:'inline-flex',alignItems:'center',gap:4,
                  margin:'0 4px 6px 0',padding:'5px 10px',borderRadius:20,cursor:'pointer',
                  background:reqFields.includes(f)?'#eff6ff':'#f1f5f9',
                  border:`1px solid ${reqFields.includes(f)?'#1a3cc8':'#e2e8f0'}`,
                  fontSize:11,fontWeight:600,
                  color:reqFields.includes(f)?'#1a3cc8':'#64748b'}}>
                {reqFields.includes(f)?'✓ ':''}{f}
              </div>
            ))}
          </div>
          <textarea value={reqPurpose} onChange={e=>setReqPurpose(e.target.value)}
            placeholder="Purpose: e.g. Hiring for Senior Developer role at ABC Corp"
            style={{width:'100%',padding:'10px 12px',borderRadius:10,
              border:'1px solid #e2e8f0',fontSize:12,resize:'none',
              height:80,boxSizing:'border-box',fontFamily:'inherit',marginBottom:14}}/>
          <button onClick={async()=>{
            if(reqFields.length===0){alert('Select at least one field');return;}
            const res = await fetch(`${API}/api/backend/v1/gap/access-requests`,{
              method:'POST',headers:hdr(),
              body:JSON.stringify({subject_id:uid,fields:reqFields,purpose:reqPurpose})});
            const d = await res.json();
            if(d.success){setReqSent(true);setShowRequest(false);}
          }} style={{width:'100%',padding:12,background:'#1a3cc8',border:'none',
            borderRadius:12,color:'#fff',fontSize:14,fontWeight:700,cursor:'pointer'}}>
            Send Request
          </button>
        </div>
      </div>
    )}
    </div>
  );
}
